<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add CMS Page</h2>
      <h2 v-if="isEdit" class="text-center">Edit CMS Page</h2>
    </div>

    <div class="row">
      <div class="col-md-12">
        <card>
          <form onSubmit="return false;">
            <div class="row">
              <div class="col-md-6">
                <label>Page Type *</label>
                <select
                  v-model="page_type"
                  class="location form-control"
                  style="width: 100%; color: white !important"
                >
                  <option value="" style="color: black !important">
                    Select page
                  </option>
                  <option
                    v-for="page in pageTypes"
                    :key="page.value"
                    :value="page.value"
                    style="color: black !important"
                  >
                    {{ page.label }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <base-input
                  type="text"
                  label="Title *"
                  maxlength="100"
                  placeholder="Title"
                  v-model="title"
                >
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Status</label>
                <select
                  v-model="status"
                  class="location form-control"
                  style="width: 100%; color: white !important"
                >
                  <option value="active" style="color: black !important">
                    Active
                  </option>
                  <option value="inactive" style="color: black !important">
                    Inactive
                  </option>
                </select>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <rich-text-editor
                  v-model="content"
                  label="Content *"
                  placeholder="Write the CMS page content"
                />
              </div>
            </div>

            <base-button
              v-if="!isEdit"
              native-type="submit"
              type="primary"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="saveCmsPage()"
            >
              Save
            </base-button>

            <base-button
              v-if="isEdit"
              native-type="submit"
              type="primary"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="saveCmsPage()"
            >
              Update
            </base-button>
          </form>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import RichTextEditor from "src/components/RichTextEditor.vue";

const API_ENDPOINTS = {
  getBySlug: "cms-data/get-by-slug/",
  create: "cms-data/create",
  update: "cms-data/update/",
};

const CMS_HTML_WRAPPER_ATTRIBUTE = "data-cms-html-content";
const CMS_HTML_WRAPPER_STYLES = {
  backgroundColor: "#000000",
  boxSizing: "border-box",
  color: "#ffffff",
  fontFamily: "Arial, Helvetica, sans-serif",
  minHeight: "100%",
  padding: "16px",
};
const CMS_TEXT_TAGS = [
  "a",
  "blockquote",
  "div",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "li",
  "ol",
  "p",
  "span",
  "strong",
  "em",
  "u",
  "ul",
];

const PAGE_TYPES = [
  { label: "About Us", page_type: "about-us", slug: "about-us" },
  {
    label: "Terms & Conditions",
    page_type: "terms-conditions",
    slug: "terms-conditions",
  },
  { label: "Privacy Policy", page_type: "privacy-policy", slug: "privacy-policy" },
  { label: "Refund Policy", page_type: "refund-policy", slug: "refund-policy" },
];

export default {
  components: {
    RichTextEditor,
  },
  data() {
    return {
      title: "",
      page_type: "",
      content: "",
      status: "active",
      isEdit: false,
      loading: false,
      cmsId: "",
      pageTypes: PAGE_TYPES.map((item) => ({
        label: item.label,
        value: item.page_type,
      })),
    };
  },
  async mounted() {
    const id = this.$route.query.id;
    const pageType = this.$route.query.page_type || "";
    const slug = this.$route.query.slug || this.getSlugFromPageType(pageType);

    if (pageType) {
      this.page_type = pageType;
    }

    if (id == -1) {
      this.isEdit = false;
      this.setDefaultTitle();
      return;
    }

    await this.loadCmsPage(slug);
  },
  watch: {
    page_type() {
      this.setDefaultTitle();
    },
  },
  methods: {
    async loadCmsPage(slug) {
      if (!slug) {
        this.$apiService.notify("Page slug is required.");
        this.$router.push("/cms/list");
        return;
      }

      this.loading = true;
      try {
        const response = await this.$apiService.getCall(
          API_ENDPOINTS.getBySlug + slug
        );
        if (response.isError) {
          this.$apiService.notify("Unable to load CMS page.");
          this.$router.push("/cms/list");
          return;
        }

        const page = this.extractRecord(response.apidata);
        if (!page) {
          this.$apiService.notify("CMS page was not found.");
          this.$router.push("/cms/list");
          return;
        }

        this.cmsId = page._id || page.id || "";
        this.title = page.title || page.page_title || page.name || "";
        this.page_type = page.page_type || page.slug || page.type || page.key || "";
        this.content = this.cleanEditorHtml(
          page.html ||
            page.content ||
            page.description ||
            page.body ||
            ""
        );
        this.status = this.getInitialStatus(page);
        this.isEdit = Boolean(this.cmsId);
      } finally {
        this.loading = false;
      }
    },
    extractRecord(apiData) {
      const candidates = [
        apiData && apiData.Data,
        apiData && apiData.data,
        apiData && apiData.cms,
        apiData && apiData.page,
        apiData && apiData.result,
      ];

      for (const item of candidates) {
        if (!item) continue;
        if (Array.isArray(item)) return item[0];
        if (item.page) return item.page;
        if (item.cms) return item.cms;
        return item;
      }

      return null;
    },
    getInitialStatus(page) {
      if (page.status) return page.status.toString().toLowerCase();
      if (page.active_status === false || page.is_active === false) return "inactive";
      return "active";
    },
    stripContent(html) {
      return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim();
    },
    buildHtmlContent() {
      const html = this.cleanEditorHtml(this.content || "").trim();
      if (!html) return "";

      return this.wrapContentForMobileHtmlReader(html);
    },
    cleanEditorHtml(html) {
      if (!html) return "";

      const container = document.createElement("div");
      container.innerHTML = html;
      this.removeUnsupportedStyles(
        Array.from(container.querySelectorAll("*"))
      );

      return container.innerHTML;
    },
    removeUnsupportedStyles(elements) {
      elements.forEach((element) => {
        element.style.removeProperty("width");
        element.style.removeProperty("line-height");
        element.removeAttribute("width");
      });
    },
    wrapContentForMobileHtmlReader(html) {
      const container = document.createElement("div");
      container.innerHTML = html;

      const existingWrapper = this.getExistingHtmlWrapper(container);
      const wrapper = existingWrapper || document.createElement("div");

      if (!existingWrapper) {
        wrapper.innerHTML = html;
      }

      wrapper.setAttribute(CMS_HTML_WRAPPER_ATTRIBUTE, "true");
      this.applyInlineStyles(wrapper, CMS_HTML_WRAPPER_STYLES);
      this.applyReadableTextStyles(wrapper);
      this.removeUnsupportedStyles(
        [wrapper].concat(Array.from(wrapper.querySelectorAll("*")))
      );

      return wrapper.outerHTML;
    },
    getExistingHtmlWrapper(container) {
      const children = Array.from(container.children);

      if (children.length !== 1) return null;
      if (!children[0].hasAttribute(CMS_HTML_WRAPPER_ATTRIBUTE)) return null;

      return children[0];
    },
    applyReadableTextStyles(wrapper) {
      CMS_TEXT_TAGS.forEach((tagName) => {
        wrapper.querySelectorAll(tagName).forEach((element) => {
          element.style.color = "#ffffff";
          element.style.backgroundColor = "transparent";
        });
      });

      wrapper.querySelectorAll("a").forEach((link) => {
        link.style.textDecoration = "underline";
      });
    },
    applyInlineStyles(element, styles) {
      Object.keys(styles).forEach((key) => {
        element.style[key] = styles[key];
      });
    },
    getSlugFromPageType(pageType) {
      const page = PAGE_TYPES.find((item) => item.page_type === pageType);
      return page ? page.slug : pageType;
    },
    setDefaultTitle() {
      if (this.title) return;

      const page = PAGE_TYPES.find((item) => item.page_type === this.page_type);
      if (page) {
        this.title = page.label;
      }
    },
    async saveCmsPage() {
      if (!this.page_type) {
        this.$apiService.notify("Page type is mandatory.");
        return;
      }
      if (!this.title) {
        this.$apiService.notify("Title is mandatory.");
        return;
      }
      if (!this.stripContent(this.content)) {
        this.$apiService.notify("Content is mandatory.");
        return;
      }

      this.loading = true;

      try {
        const htmlContent = this.buildHtmlContent();
        const payload = {
          title: this.title.trim(),
          page_type: this.page_type,
          content: htmlContent,
          html: htmlContent,
          body: htmlContent,
          description: htmlContent,
          status: this.status,
        };

        const id = this.cmsId || this.$route.query.id;
        const response = this.isEdit
          ? await this.$apiService.putCall(API_ENDPOINTS.update + id, payload)
          : await this.$apiService.postCall(API_ENDPOINTS.create, payload);

        if (response.isError || this.hasApiFailure(response.apidata)) {
          this.$apiService.notify(this.getApiMessage(response.apidata));
          return;
        }

        this.$apiService.notify(
          this.isEdit ? "CMS page has been updated." : "CMS page has been added."
        );
        this.$router.push("/cms/list");
      } finally {
        this.loading = false;
      }
    },
    hasApiFailure(apiData) {
      return apiData && apiData.Code && apiData.Code !== "P00001";
    },
    getApiMessage(apiData) {
      return (apiData && apiData.Message) || "Unable to save CMS page.";
    },
  },
};
</script>

<style scoped>
.location {
  background: #27293d;
  border: 1px solid #2b3553;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  padding: 8px;
  width: 100%;
}

form label {
  font-weight: 600;
}
</style>
